<template>
  <div id="messages" v-if="messages !== null">
    <br v-if="rolagemDaPagina(messages.message)" />
    <b-alert
      v-model="showDismissibleAlert"
      :variant="defineVariant"
      dismissible
    >
      <span v-if="!lstErros">
        <i :class="getIcon"></i>
        {{ messages.message }}
      </span>
      <p class="mb-0" v-if="messages.errors" />
      <span v-else>
         <p v-for="e in lstErros" :key="e.message">
         <i :class="getIcon"></i>
         <span v-html="`${ e.message } ${ e.code ? '(' + e.code + ')' : '' }`"></span>
        </p>
      </span>
    </b-alert>
  </div>
</template>
<script>
export default {
  name: 'Messages',
  data () {
    return {
      show: true
    }
  },
  computed: {
    isLstErros() {
      return this.lstErros.length > 0
    },
    lstErros () {
        return this.messages?.message?.errors == undefined ? [] : this.messages?.message?.errors
    },
    messages: {
      get () {
        return this.$store.getters['message/getMessages']
      }
    },
    defineVariant () {
      if (this.messages.variant != null) {
        return this.messages.variant
      } else {
        return 'danger'
      }
    },
    showDismissibleAlert: {
      get () {
        if (this.messages.message) {
          return true
        } else {
          return false
        }
      },
      set () {
        this.$store.commit('setMessages', '')
        return true
      }
    },
    getIcon () {
      var icon
      switch (this.messages.variant) {
        case 'warning':
          icon = 'fas fa-exclamation-triangle'
          break
        case 'danger':
          icon = 'fas fa-exclamation-circle'
          break
        case 'info':
          icon = 'fas fa-info-circle'
          break
        case 'success':
          icon = 'fas fa-check-circle'
          break
        default:
          icon = 'fas fa-exclamation-circle'
      }
      return icon
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  methods: {
    rolagemDaPagina(mensagem) {
      if(mensagem) {
        document.getElementById('messages').scrollIntoView({behavior: "smooth"});
        return true
      }
      return false
  }
  }
}
</script>
